import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { OFFER_ANCHOR, popupSales } from '../data/salesCopy';
const MINUTES = [3, 5, 7, 9, 11, 14, 18, 22];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = window.setTimeout(() => setVisible(true), 6000);
    const interval = window.setInterval(() => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % popupSales.length);
        setVisible(true);
      }, 900);
    }, 14000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(timeout);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const sale = popupSales[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 w-[244px] animate-pop-in rounded-lg border-[3px] border-brand-gold bg-white p-2.5 pr-6 shadow-[0_0_0_2px_rgba(82,100,81,0.9),0_10px_24px_-10px_rgba(64,54,47,0.6)] sm:w-[272px]" data-id="element-158" data-mp="1657iyycnnjwl">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="absolute right-1 top-1 rounded p-1 text-brand-taupe transition-colors duration-150 ease-smooth hover:text-brand-brown" data-id="element-159" data-mp="1awzd1iv0s7rh">
        <XIcon className="h-3.5 w-3.5" data-id="element-160" data-mp="ia4vatpl7mhp" />
      </button>
      <a href={OFFER_ANCHOR} className="flex items-start gap-2" data-id="element-161" data-mp="x6caffm51xq4">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-cta" data-id="element-162" data-mp="s6hkpfe3ne6n">
          <CheckCircle2Icon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-163" data-mp="28jyahvtjdjqf" />
        </span>
        <span className="min-w-0" data-id="element-164" data-mp="23lmypfjokz5k">
          <span className="block text-[11.5px] font-bold leading-tight text-brand-brown" data-id="element-165" data-mp="23kleolkot2bp">
            {sale.name} — {sale.city}, {sale.country}
          </span>
          <span className="block text-[11px] font-medium leading-tight text-brand-taupe" data-id="element-166" data-mp="2fne9xinriwsc">
            vient d’obtenir YIN YOGA PRO™
          </span>
          <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-wide text-brand-gold" data-id="element-167" data-mp="2knad5fomyk6u">
            il y a {minutes} minutes
          </span>
        </span>
      </a>
    </div>;
}